import { Card, CardContent } from "@/components/ui/card";
import { Transliterator } from "./components/Transliterator";
import { ThemeToggle } from "./components/ThemeToggle";
import "./index.css";

export function App() {
  return (
    <>
      <header className="sr-only">
        <h1>Kazakh Transliterator - Free Online Qazaq Latin Cyrillic Converter</h1>
        <p>Convert Kazakh (Qazaq) text between Latin, Cyrillic, and Russian alphabets instantly.</p>
      </header>

      <main className="w-full p-4 sm:p-6 lg:p-8 text-center relative z-10">
        <Card className="w-full bg-card/50 backdrop-blur-sm border-muted relative">
          {/* Theme Toggle - Top Right Corner */}
          <div className="absolute top-4 right-4 z-10">
            <ThemeToggle />
          </div>

          <CardContent className="pt-4 sm:pt-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold my-2 sm:my-4 leading-tight">
              QazLatin - Қазақ Латын
            </h1>
            <p className="text-sm sm:text-base mb-2">
              Kazakh Transliterator (Latin ⇄ Cyrillic • Russian → Kazakh • English → Qazaq Latin)
            </p>
            <p className="text-xs sm:text-sm text-muted-foreground mb-4">
             Online tool for Kazakh language • қазақ тілі конвертері
            </p>
            <Transliterator />
          </CardContent>
        </Card>

        {/* SEO Content Section */}
        <section className="mt-8 max-w-4xl mx-auto text-left">
          <article className="bg-card/30 rounded-lg p-6 space-y-4 text-sm">
            <h2 className="text-2xl font-bold text-foreground">About Kazakh (Qazaq) Transliteration</h2>

            <div className="space-y-3 text-muted-foreground">
              <p>
                <strong>QazLatin</strong> is a online Kazakh transliteration tool designed for converting text between different alphabets used in Kazakhstan. Whether you're working with Kazakh Latin script (Qazaq Latin), Kazakh Cyrillic (қазақ кирилл), or Russian text, our tool provides instant, accurate conversions.
              </p>

              <h3 className="text-lg font-semibold text-foreground mt-4">Kazakh Language Support</h3>
              <p>
                The Kazakh language (қазақ тілі, qazaq tılı) is the official language of Kazakhstan, spoken by over 13 million people worldwide.
              </p>

              <h3 className="text-lg font-semibold text-foreground mt-4">Features for Kazakh Speakers</h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Kazakh Cyrillic to Latin:</strong> Convert қазақ кирилл text to modern Latin alphabet with diacritics</li>
                <li><strong>Latin to Kazakh Cyrillic:</strong> Type in Latin and get Cyrillic output instantly</li>
                <li><strong>Russian to Kazakh:</strong> Convert Russian text to proper Kazakh Cyrillic</li>
                <li><strong>English to Qazaq Latin:</strong> Transform English alphabet text to Kazakh Latin with special characters</li>
                <li><strong>Real-time conversion:</strong> See results as you type</li>
                <li><strong>Bidirectional support:</strong> Work in any direction you need</li>
              </ul>

              <h3 className="text-lg font-semibold text-foreground mt-4">Kazakh Alphabet (Қазақ әліпбиі)</h3>
              <p>
                The Kazakh alphabet has gone through several changes throughout history. Currently, Kazakhstan uses Cyrillic script, but there's an ongoing transition to Latin script. Our tool supports both systems and helps users work with modern Kazakh Latin alphabet that includes special letters like Ә (ä), Ө (ö), Ү (ü), Ұ (ū), Қ (q), Ғ (ğ), Һ (h), І (ı), and Ң (ñ).
              </p>

              <p>
                Whether you're a native Kazakh speaker (қазақша сөйлеуші), learning the Kazakh language, working on Kazakhstan-related documents, or need to transliterate names and places, QazLatin provides accurate, instant conversions. Our tool respects the linguistic nuances of both Qazaq Latin and Cyrillic scripts.
              </p>

              <h3 className="text-lg font-semibold text-foreground mt-4 hidden">Keywords</h3>
              <p className="text-xs hidden">
                Kazakh transliteration, Qazaq Latin, Kazakh Cyrillic, қазақ латын, қазақ кирилл, Kazakhstan language converter, Kazakh to Latin converter, Latin to Kazakh, Russian to Kazakh, қазақша, қазақ тілі, Kazakh alphabet, қазақ әліпбиі, transliterator, транслитерация, дыбыстау, Qazaq tilı, қазақ латын әліпбиі, Kazakh Latin alphabet, Cyrillic to Latin Kazakh.
              </p>
            </div>
          </article>
        </section>
      </main>

      <footer className="text-center py-6 text-xs text-muted-foreground">
        <p>© 2025 QazLatin - Kazakh Transliteration Tool</p>
      </footer>
    </>
  );
}

export default App;
